/**
 * Proportional Scaler (Native Mobile Viewport Scaling)
 * Scales the UI perfectly on iPads/Tablets by dynamically adjusting the viewport meta tag.
 * This avoids all issues with CSS zoom, transform, fixed positioning, and vw units.
 */
document.addEventListener('DOMContentLoaded', () => {
  const baseWidth = 1366;
  const mobileBreakpoint = 750;

  function applyProportionalScaling() {
    // window.screen.width returns the physical/emulated device width, not the CSS layout width.
    // This avoids infinite loops when we change the viewport meta tag.
    const isPortrait = window.innerHeight >= window.innerWidth;
    const screenW = window.screen.width;
    const screenH = window.screen.height;
    
    // Detect current orientation's physical width
    let currentPhysicalWidth = screenW;
    // Some older iOS versions don't swap screen.width/height on rotate, 
    // but in modern browsers and Chrome DevTools it usually does. 
    // We'll trust screenW for the most part.
    
    const viewportMeta = document.querySelector('meta[name="viewport"]');
    if (!viewportMeta) return;

    if (currentPhysicalWidth >= mobileBreakpoint && currentPhysicalWidth < baseWidth) {
      // Force the layout to 1366px. Mobile browsers will natively scale it down to fit the screen.
      viewportMeta.setAttribute('content', `width=${baseWidth}`);
    } else {
      // For mobile (<750px) or large desktop (>1366px), use normal responsive behavior
      viewportMeta.setAttribute('content', 'width=device-width, initial-scale=1.0');
    }
    
    // Clean up any old CSS zoom styles that were previously applied
    document.body.style.zoom = '';
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('max-width');
    document.body.style.removeProperty('overflow-x');
    document.documentElement.style.removeProperty('overflow-x');
  }

  // Ejecutar al cargar
  applyProportionalScaling();
  
  // Escuchar cambios de orientación (girar el iPad)
  window.addEventListener('orientationchange', () => {
    setTimeout(applyProportionalScaling, 150);
  });
});
